import { ChangeDetectionStrategy, Component, inject, input, InputSignal, InputSignalWithTransform } from '@angular/core';

import { HoldingFileReqRes } from 'src/app/dashboard/shared/holding/HoldingFileReqRes.model';
import { ResourceService } from 'src/app/services/resource.service';
import { HoldingFileType } from 'src/app/shared/enums/HoldingFileType.enum';
import { LocationDetailsResponse } from 'src/app/shared/models/LocationDetailsResponse.model';

@Component({
  selector: 'terra-holding-images',
  templateUrl: './holding-images.component.html',
  styleUrl: './holding-images.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HoldingImagesComponent {
  // Dependencies 
  resourceService = inject(ResourceService);

  // Inputs
  singleLineAddress: InputSignal<boolean> = input(false); 
  showArrows: InputSignal<boolean> = input(true); 
  showText: InputSignal<boolean> = input(true); 

  holdingFiles: InputSignalWithTransform<Array<string>, Array<HoldingFileReqRes>>= input([], {
    transform: (v: Array<HoldingFileReqRes>) => this.getPhotoUrls(v),
  }); 

  location: InputSignalWithTransform<string, LocationDetailsResponse> = input(null, {
    transform: (v: LocationDetailsResponse) => this.getFormattedAddress(v),
  })

  
  private getFormattedAddress(location: LocationDetailsResponse) {
    if (!location) {
      return '';
    }

    let formattedString = '';
    if (location.cityName) {
      formattedString += location.cityName;
      if (location.stateName || location.postalCode) {
        formattedString += ', ';
      }
    }
    if (location.stateName) {
      formattedString += location.stateName;
      if (location.postalCode) {
        if (!this.singleLineAddress()) {
          formattedString += ', <br/>';
        } else {
          formattedString += ', ';
        }
      }
    }
    if (location.postalCode) {
      formattedString += location.postalCode;
    }

    const country = this.resourceService.getCountryById(location.countryId);

    if (country && country.code) {
      if (!formattedString) {
        formattedString += country.name;
      } else {
        formattedString += ', ' + country.code;
      }
    }
    return formattedString;
  }

  private getPhotoUrls(holdingFiles: HoldingFileReqRes[]): string[] {
    const photos = holdingFiles
      ?.filter(x => x.fileType === HoldingFileType.Photo)
      .map((assetFile: HoldingFileReqRes) => assetFile.metaFileLink.url) || [];
    return [...photos];
  }
}
